module.exports = __webpack_public_path__ + "static/img/system_01.24fbbc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/system_01.png
// module id = 7TjY
// module chunks = 1